import React, { Component  } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { ScrollView, LoadingView } from '../../../../common/components/atoms';
import { HeaderTitle } from '../../../components/molecues';

class WebinarArchive extends Component {
 
    constructor(props) {
        super(props);

        this.refScroll = React.createRef();
        this.state = {
            current: 3,
            date: [],
            title: [],
            video: [],
            count:0,
            videoData: this.props.videoData,
        }
    }
    
    componentDidMount() {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.webinarArchiveReload();
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }
    webinarArchiveReload = () => {
        let webAcvFlg = this.props.webAcvFlg;
        this.props.dispatch({
            type: "GetWebinarArchiveList_Saga",
            deleteFlg: 0,
            onSuccess: this.onSuccessGetWebinarArchiveList,
            onFailure: this.onFailure,
        });
        this.props.dispatch({
            type: "SetWebinarArchiveRead_Saga",
            userID: this.props.user.id,
            onSuccess: this.onSuccessSetWebinarArchiveRead,
            onFailure: this.onFailure,
        });
    }
    onSuccessSetWebinarArchiveRead = (items) => {
    }
    onSuccessGetWebinarArchiveList = (items) => {
        let listMax = 12;
        let date_copy = [];
        let title_copy = [];
        let video_copy = [];
        let count = listMax;
        for(let i=0; i <= listMax; i++ ){
            if(items[i] === null){
                count = i;
                i = listMax + 1;
            }else{
                date_copy[i] = items[i].date;
                title_copy[i] = items[i].title;
                video_copy[i] = items[i].video;
            }
        }
        this.setState({
            date: date_copy,
            title: title_copy,
            video: video_copy,
            count: Number(count),
        });
    }
    onClickHome = () => {
        this.props.history.replace('/home');
    }
    onClickVideo(video) {
        this.props.dispatch({
            type: "LoadVideo",
            acvFileName: video,
        });
        this.props.history.push('/VideoWebinarArchive');
    }
    createArchive() {
        let list = [];
        let cnt = this.state.count;
        list.push(<Text key={"text"}>これまでのウェビナーの録画をご視聴いただけます。</Text>);    
        for(let i=0; i < cnt; i++){
            list.push(
                <ArchiveSelection key={i + "verCourse"} onClick={e => this.onClickVideo(this.state.video[i])}>
                    <ArchiveIcon key={i + "icon"}>
                        <i className="fas fa-play" />
                    </ArchiveIcon>
                    <ArchiveTextGroup key={i + "group"}>
                        <ArchiveTextA key={i + "textA"}>
                            {this.state.date[i] + " 開催"}
                        </ArchiveTextA>
                        <ArchiveTextB key={i + "textB"}>
                            {this.state.title[i]}
                        </ArchiveTextB>
                    </ArchiveTextGroup>
                </ArchiveSelection>
            );
        }
        return list;
    }
    render() {
        const propsHeader = {
            current: this.state.current,
            onClickHome: this.onClickHome,
        };
        const propsCreateArchive = {
            width: '100%',
            height: (window.innerHeight - 64) + "px",
            contents: this.createArchive()
        }
        
        return (
            <Body>
                <HeaderTitle {...propsHeader}></HeaderTitle>
                <ScrollView ref={this.refScroll} {...propsCreateArchive} />
            </Body>
        );
    }
}

const mapStateToProps = store => {
    return {
        user: store.login.user,
        loading: store.loading.loading,
        webAcvFlg: store.home.webAcvFlg,
    }
};

const connectedWebinarArchive = connect(mapStateToProps)(WebinarArchive);
export { connectedWebinarArchive as WebinarArchive };

const Body = styled.div`
`;
const Text = styled.div`
    width: 93%;
    font-size:14px;
    padding:10px;
    border-top-style: none
    border-right-style: none
    border-bottom-style: solid
    border-left-style: none
    border-color: #f2f2f2;
`;

const ArchiveSelection  = styled.div`
    width:95%;
    display:flex;
    margin:2px 0 0 10px;
    border-top-style: none
    border-right-style: none
    border-bottom-style: solid
    border-left-style: none
    border-color: #f2f2f2;
`;
const ArchiveIcon = styled.div`
    margin:auto 5px;
    font-size:18px;
    color: #00b050;
`;
const ArchiveTextGroup  = styled.div`
`;
const ArchiveTextA = styled.div`
    font-size:13px;
`;
const ArchiveTextB = styled.div`
    font-size:18px;
    font-weight: bold;
`;